import { useState } from 'react';

const features = [
  {
    icon: 'ri-flight-takeoff-line',
    title: 'Express Kurye Servisi',
    desc: 'Kapıdan kapıya uluslararası kurye hizmeti. Belgeler ve küçük paketler için ideal çözüm.',
  },
  {
    icon: 'ri-box-3-line',
    title: 'Uluslararası Kargo',
    desc: 'Hava, deniz ve kara yoluyla tüm dünyaya kargo taşımacılığı. Her ölçekte gönderi.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Sigortalı Taşıma',
    desc: 'Tüm gönderileriniz sigorta kapsamında. Güvenli teslimat garantisi.',
  },
  {
    icon: 'ri-file-text-line',
    title: 'A.TR Belgesi',
    desc: 'AB ülkeleri için menşe şahadetnamesi hazırlığı ve gümrük işlemleri desteği.',
  },
];

const destinations = [
  { country: 'Almanya', code: 'DE', cities: ['Frankfurt', 'Berlin', 'Münih'] },
  { country: 'Hollanda', code: 'NL', cities: ['Amsterdam', 'Rotterdam'] },
  { country: 'İngiltere', code: 'GB', cities: ['Londra', 'Manchester'] },
  { country: 'Fransa', code: 'FR', cities: ['Paris', 'Lyon'] },
  { country: 'İtalya', code: 'IT', cities: ['Roma', 'Milano'] },
  { country: 'İspanya', code: 'ES', cities: ['Madrid', 'Barselona'] },
  { country: 'ABD', code: 'US', cities: ['New York', 'Los Angeles'] },
  { country: 'Birleşik Arap Emirlikleri', code: 'AE', cities: ['Dubai', 'Abu Dabi'] },
];

export default function AirFreightSection() {
  const [activeDest, setActiveDest] = useState(0);

  return (
    <section
      className="relative overflow-hidden"
      style={{ background: 'var(--bg)', padding: '100px 0', borderTop: '1px solid var(--border)' }}
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20cargo%20airplane%20flying%20above%20clouds%20at%20golden%20hour%2C%20dramatic%20cinematic%20lighting%2C%20orange%20and%20warm%20tones%2C%20professional%20aviation%20photography%2C%20wide%20angle%20shot%20showing%20wing%20and%20sky%2C%20ultra%20high%20quality&width=1440&height=700&seq=airfreight-bg-v3&orientation=landscape"
          alt="Havayolu Kargo"
          className="w-full h-full object-cover object-top"
          style={{ opacity: 0.08 }}
        />
        <div
          className="absolute inset-0"
          style={{
            background: 'radial-gradient(ellipse 70% 60% at 20% 50%, rgba(232,97,26,0.06) 0%, transparent 65%)',
          }}
        ></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="label reveal justify-center">
            <div className="label-dot"></div>
            Uluslararası Kargo Taşımacılığı
          </div>
          <h2
            className="reveal h-font mt-4"
            style={{
              fontFamily: 'var(--font-h)',
              fontWeight: 800,
              fontSize: 'clamp(36px, 4.5vw, 56px)',
              color: 'var(--text1)',
              lineHeight: 1.1,
            }}
          >
            <span className="text-gradient">200+ Ülkeye</span> Teslimat
          </h2>
          <p className="reveal d2 text-base leading-relaxed mt-4 mx-auto max-w-2xl" style={{ color: 'var(--text2)' }}>
            CargoNet ile dünyanın her yerine hızlı, güvenli ve ekonomik kargo gönderin. 
            Express kurye, havayolu kargo ve denizyolu seçenekleriyle yanınızdayız.
          </p>
        </div>

        {/* Stats Row */}
        <div className="reveal grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {[
            { icon: 'ri-global-line', n: '200+', l: 'Ülkeye Teslimat', sub: 'Teslimat ağı' },
            { icon: 'ri-send-plane-line', n: '8400+', l: 'Aylık Gönderi', sub: 'Ortalama hacim' },
            { icon: 'ri-archive-stack-line', n: '4600+', l: 'Fulfillment Dağıtım', sub: 'Aylık dağıtım' },
          ].map((s, i) => (
            <div
              key={i}
              className={`d${i + 1} flex items-center gap-5 p-6 rounded-2xl`}
              style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-2xl flex-shrink-0"
                style={{ background: 'rgba(232,97,26,0.12)' }}
              >
                <i className={s.icon} style={{ color: 'var(--orange)', fontSize: 24 }}></i>
              </div>
              <div>
                <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 32, color: 'var(--text1)', lineHeight: 1 }}>{s.n}</div>
                <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--orange)', marginTop: 4 }}>{s.l}</div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>{s.sub}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          
          {/* LEFT — Features */}
          <div className="lg:col-span-5 space-y-4">
            {features.map((f, i) => (
              <div
                key={i}
                className={`reveal d${i + 1} flex gap-4 p-5 rounded-2xl`}
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--border)',
                }}
              >
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0"
                  style={{ background: 'rgba(232,97,26,0.12)', border: '1px solid rgba(232,97,26,0.2)' }}
                >
                  <i className={`${f.icon}`} style={{ color: 'var(--orange)', fontSize: 20 }}></i>
                </div>
                <div>
                  <h3 style={{ fontWeight: 800, fontSize: 15, color: 'var(--text1)', marginBottom: 4 }}>{f.title}</h3>
                  <p style={{ fontSize: 13, color: 'var(--text3)', lineHeight: 1.6 }}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT — Destinations Map */}
          <div className="lg:col-span-7">
            <div
              className="reveal d3 rounded-2xl overflow-hidden h-full"
              style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
            >
              {/* Panel header */}
              <div
                className="px-6 py-4 flex items-center justify-between"
                style={{ borderBottom: '1px solid var(--border)', background: 'var(--panel-header)' }}
              >
                <div className="flex items-center gap-3">
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl"
                    style={{ background: 'rgba(232,97,26,0.15)' }}
                  >
                    <i className="ri-map-pin-2-line" style={{ color: 'var(--orange)', fontSize: 18 }}></i>
                  </div>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 15, color: 'var(--text1)' }}>Teslimat Noktaları</div>
                    <div style={{ fontSize: 12, color: 'var(--text3)' }}>Avrupa, Amerika, Orta Doğu ve daha fazlası</div>
                  </div>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse inline-block"></span>
                  <span style={{ fontSize: 12, color: 'var(--text3)' }}>Aktif</span>
                </div>
              </div>

              {/* Destinations Grid */}
              <div className="p-6">
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {destinations.map((d, i) => (
                    <div
                      key={i}
                      className="cursor-pointer transition-all duration-300 rounded-xl p-3"
                      style={{
                        background: activeDest === i ? 'rgba(232,97,26,0.08)' : 'var(--bg)',
                        border: `1px solid ${activeDest === i ? 'rgba(232,97,26,0.25)' : 'var(--border)'}`,
                      }}
                      onMouseEnter={() => setActiveDest(i)}
                    >
                      <div className="flex items-center gap-2 mb-2">
                        <img
                          src={`https://flagcdn.com/w40/${d.code.toLowerCase()}.png`}
                          alt={d.country}
                          className="w-6 h-4 object-cover rounded"
                        />
                        <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text1)' }}>{d.country}</span>
                      </div>
                      <div className="space-y-1">
                        {d.cities.map((city, ci) => (
                          <div
                            key={ci}
                            style={{ fontSize: 11, color: 'var(--text3)' }}
                          >
                            • {city}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Selected destination detail */}
                <div
                  className="mt-6 p-4 rounded-xl"
                  style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={`https://flagcdn.com/w40/${destinations[activeDest].code.toLowerCase()}.png`}
                      alt={destinations[activeDest].country}
                      className="w-8 h-6 object-cover rounded"
                    />
                    <span style={{ fontWeight: 800, fontSize: 16, color: 'var(--text1)' }}>
                      {destinations[activeDest].country}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {destinations[activeDest].cities.map((city, i) => (
                      <span
                        key={i}
                        className="px-3 py-1.5 rounded-full text-xs font-semibold"
                        style={{ background: 'rgba(232,97,26,0.1)', color: 'var(--orange)', border: '1px solid rgba(232,97,26,0.2)' }}
                      >
                        {city}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Bottom CTA */}
              <div
                className="px-6 py-4 flex items-center justify-between"
                style={{ borderTop: '1px solid var(--border)', background: 'var(--panel-header)' }}
              >
                <span style={{ fontSize: 13, color: 'var(--text3)' }}>+15 ülke daha mevcut</span>
                <a
                  href="/hizmetler"
                  className="inline-flex items-center gap-1.5 text-sm font-bold whitespace-nowrap"
                  style={{ color: 'var(--orange)' }}
                >
                  Tüm Hizmetleri Gör <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
